import { render, staticRenderFns } from "./cg-becomevolunteerPopup.vue?vue&type=template&id=4cc53f69&scoped=true"
import script from "./cg-becomevolunteerPopup.vue?vue&type=script&lang=js"
export * from "./cg-becomevolunteerPopup.vue?vue&type=script&lang=js"
import style0 from "./cg-becomevolunteerPopup.vue?vue&type=style&index=0&id=4cc53f69&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc53f69",
  null
  
)

export default component.exports